<template>
  <header
    class="border-t-4 border-t-[#004dc1] py-2 px-2 border-b border-b-[#004dc1] md:px-0 md:py-4 md:border-b-0"
  >
    <div class="flex justify-between items-center mx-auto md:w-[1000px]">
      <div class="logo">
        <img src="@/assets/pc/logo.png" alt="eggsy株式会社" />
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style scoped>
.logo {
  margin: 2px 10px 5px;
}
.logo img {
  width: 27%;
}
@media screen and (min-width: 980px) {
  .logo {
    width: 1200px;
    margin: 10px auto;
  }
  .logo img {
    width: 120px;
  }
}
</style>
